import { Directive, input } from "@angular/core";
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';
import { ChangeDependentValidator } from "./changedependentvalidator";

@Directive({
    selector: '[minValue]',
    providers: [{ provide: NG_VALIDATORS, useExisting: MinValueValidatorDirective, multi: true }],
    standalone: true
})

export class MinValueValidatorDirective extends ChangeDependentValidator implements Validator {
    readonly minValue = input<number | Date>(undefined);

    constructor() {
        super(['minValue']);
    }

    validate(control: AbstractControl): ValidationErrors | null {
        const controlValueExists: boolean = control.value !== null && control.value !== undefined;
        const minValue = this.minValue();
        const maxValueProvided: boolean = minValue !== null && minValue !== undefined;
        const error: ValidationErrors = controlValueExists && maxValueProvided && control.value < this.minValue()
            ? { "min": `Number cannot be less than ${this.minValue()}` }
            : null;
        return error;
    }
}
